import React, {Component} from 'react';
import {Button, Col, Input, Label} from "reactstrap";


class AuthModulesTabView extends Component {

	constructor(props) {
		super(props)


		this.onChange = this.onChange.bind(this);
		this.onSave = this.onSave.bind(this);
	}

	componentDidMount() {
	}

	onSave(e){

		if(!e) return;

		e.preventDefault();

		if(this.props.canSave === true){
			this.props.saveListener();
		}

	}

	onChange(e,i,j){
		if(!e) e.preventDefault();

		let target = e.target;
		const value = target.type === 'checkbox' ? (target.checked) : target.value;

		this.props.listener(value,i,j)
	}



	render() {
		let {modules,activeTab,roleName} = this.props;

		return (
			<div className="col-sm-12 row">
				<div className="col-sm-12 row">
					<Label sm={2}>Yetki Grubu Adı</Label>
					<Col sm={4}>
						<Input type="text" name="roleName" value={roleName}
							   onChange={e => this.onChange(e,undefined,undefined)}/>
					</Col>
				</div>
				<div className="col-sm-12 row card-nav-tabs card-plain">
					<div className="card-header card-header-danger">
						<div className="nav-tabs-navigation">
							<div className="nav-tabs-wrapper">
								<ul className="nav nav-tabs" data-tabs="tabs">
									{modules.map((module, i) =>
										<li key={i} className="nav-item ">
											<a className={"nav-link  " + (activeTab === module.id ? 'active' : '')}
											   onClick={() => {
												   this.props.tabListener(module.id);
											   }}
											   data-toggle="tab">{module.name}</a>
										</li>)
									}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-sm-12">
					<div className="card-body ">
						<div className="tab-content  ">
							{modules.map((module, i) =>
								<div key={i}
									 className={"tab-pane " + (activeTab === module.id ? 'active' : '')}
									 id={module.id}>
									{(module && module.privileges) &&
									<div>
										{
											module.privileges.map((privilege, j) =>
												<div key={j}>
													<Label key={j} className="noselect" check>
														<Input type="checkbox"
															   value={!!privilege.selected}
															   checked={!!privilege.selected}
															   bsSize={"15px"}
															   onChange={(e) => this.onChange(e, i, j)}/>{' '}
														{privilege.label}
													</Label>
												</div>
											)
										}
									</div>
									}
								</div>
							)
							}
						</div>
						{this.props.showSaveButton &&
							<div className="row col-sm-12">
								<div className="col-sm-5"/>
								<Button type="button" disabled={!this.props.canSave || this.props.saving} onClick={this.onSave}
										className=" TekBtn kaydet pull-right">Güncelle
								</Button>
								<div className="col-sm-5"/>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}

}

export default AuthModulesTabView;